import {getAmount} from "../../../../utils";
import {
  TRADING_ACTION_PAYOUT_PLAN,
  TRADING_ACTION_SELL
} from "../../../../../../components/ChartsV2/InstrumentsAllocationTable/constants";

export const getTotal = (items, getItemAmount) => {
  return items.filter(i => !i.isSwitchInItem && !i.isSwitchOutItem).reduce((sum, item) => {
    let amount = getItemAmount ? getItemAmount(item) : getAmount(item, null, item.switchOutItem);
    if([TRADING_ACTION_SELL, TRADING_ACTION_PAYOUT_PLAN].includes(item.tradingType)) {
      amount = -amount;
    }
    return sum + amount
  }, 0)
}